module.exports = __webpack_public_path__ + "img/placeholder-vo.eb8c3b79.png";